export { Datacenter, ErrorSource } from '@datadog/browser-core';
export { datadogRum } from './boot/rum.entry';
export { RumEventCategory } from './types';